let config = {
    currentUser: {
        hasAccessToAdminMode: false,
    },
    http: {
        root: null,
        performanceMarketing: null,
    },
    comments: {
        tagPattern: null,
    },
    externalUrls: {
        careerUrl: null,
        creatingRewardsInCrowdfundingArticle: null,
        enterpriseSolutionsUrl: null,
        forRetailersUrl: null,
        helpUrl: null,
        dynamicCurrencyConversionArticleUrl: null,
        projectDetailedDescriptionArticle: null,
        stablePledgeInformationBackerHelpUrl: null,
        stablePledgeInformationCreatorHelpUrl: null,
        stablePledgeSecureYourPledgeArticleUrl: null,
        stretchPayInformationCreatorHelpUrl: null,
        shippingGuideArticleUrl: null,
        stripeScriptUrl: null,
        reCaptchaPrivacyPolicyUrl: null,
        reCaptchaTermsUrl: null,
        gamefoundBecomeACreatorUrl: null,
        digitalServiceTaxLearnMoreUrl: null,
        performanceMarketingCatalogCampaignFeesHelpUrl: null,
    },
    socialMediaUrls: {
        facebookUrl: null,
        instagramUrl: null,
        xUrl: null,
        youTubeUrl: null,
        linkedInUrl: null,
    },
    contact: {
        joinUsMail: null,
        authoritiesMail: null,
        officialPhoneNumber: null,
        businessMail: null,
    },
    platformName: null,
    platform: null,
    navigation: {
        aboutUsUrl: null,
        accountSettingsUrl: null,
        backerCenterDashboardUrl: null,
        backerCenterPaymentsUrl: null,
        backerCenterPledgesAndOrdersUrl: null,
        backerCenterUpdatesUrl: null,
        backerCenterYourProjectsUrl: null,
        backersTermsOfServiceUrl: null,
        becomeACreatorUrl: null,
        marketingServicesUrl: null,
        blogUrl: null,
        contactUrl: null,
        cookieSettingsUrl: null,
        communityGuidelinesUrl: null,
        contentPolicyUrl: null,
        createAccountUrl: null,
        createAccountUrlWithReturn: null,
        createCreatorAccountUrl: null,
        creatorDataProcessingAgreementUrl: null,
        creatorDigitalTermsOfServiceUrl: null,
        creatorProblemBusinessContactUrl: null,
        creatorTermsOfServiceUrl: null,
        crowdfundingGuideUrl: null,
        currentActionUrl: null,
        feesUrl: null,
        homeUrl: null,
        loginUrlWithReturn: null,
        loginUrl: null,
        logoutUrl: null,
        subscriptionManagementUrl: null,
        privacyPolicyUrl: null,
        resetPasswordUrl: null,
        resetPasswordRequestSentUrl: null,
        performResetPasswordUrl: null,
        retailerProgramPrivacyPolicyUrl: null,
        retailerProgramTermsUrl: null,
        searchUrl: null,
        termsOfServiceUrl: null,
        termsOfServiceIndexUrl: null,
        userProfileUrl: null,
        joinCallbackUrl: null,
        storesTermsOfServiceUrl: null,
        joinProjectUrl: null,
        performanceMarketingTermsOfServiceUrl: null,
        performanceMarketingUrl: null,
        partnerNetworkUrl: null,
        partnerNetworkContactUrl: null,
        partnerNetworkPrivacyPolicyUrl: null,
        partnerNetworkTermsUrl: null,
        whyGamefoundUrl: null,
        intellectualPropertyPolicyUrl: null,
        reservedFundsPolicyUrl: null,
        trademarkPolicyUrl: null,
    },
    projectNavigation: {
        backProjectUrl: null,
        creatorUrl: null,
        creatorAvatarUrl: null,
        changeCurrencyUrl: null,
        projectContactUrl: null,
        projectHome: null,
        refundAndCancellationPolicyUrl: null,
        refundAndCancellationPolicyText: null,
        stretchGoalsUrl: null,
        originalCampaignUrl: null,
    },
    projectNavigationNames: {
        refundAndCancellationPolicyName: null,
    },
    pushNotifications: {
        apiKey: null,
        appID: null,
        authDomain: null,
        projectID: null,
        messagingSenderID: null,
        storageBucket: null,
        vapidKey: null,
    },
    cdn: {
        enableCdn: false,
        transformations: {},
    },
    debug: false,
    environment: null,
    paymentProviders: {
        adyen: {
            clientKey: null,
            gatewayMerchantId: '',
            merchantName: '',
            useLiveMode: false,
            pwaIosBlockedPaymentMethods: null,
            availableCardBrands: [],
        },
        googlePay: {
            merchantId: '',
            isEnabled: false,
        },
        applePay: {
            isEnabled: false,
        },
        stripe: {
            publishable: '',
        },
    },
    language: {
        currentLanguageIsoCode: null,
        fullNameCurrentLanguageIsoCode: null,
        languageSelectorEnabled: false,
    },
    externalScripts: {
        googlePayUrl: '',
        applePayUrl: '',
        googleSignInUrl: '',
        facebookSignInUrl: '',
        reCaptchaUrl: '',
        youTubeApiScriptUrl: '',
        appleSignInUrl: '',
    },
    userIdentityProviders: {
        facebook: {
            appID: null,
            isEnabled: false,
        },
        google: {
            clientID: null,
            isEnabled: false,
        },
        apple: {
            clientID: null,
            isEnabled: false,
            redirectUrl: null,
        },
    },
    orderRules: {
        availableOrderStagesForCreatorChange: null,
        orderPaymentStatusesForCrowdfundingFilters: null,
        orderPaymentStatusesForExternalPMFilters: null,
        orderPaymentStatusesForPreorderFilters: null,
        orderPaymentStatusesForStoreFilters: null,
        orderPaymentStatusForV1ProjectFilters: null,
        orderStagesForCrowdfundingFilters: null,
        orderStagesForExternalPMFilters: null,
        orderStagesForPreorderFilters: null,
        orderStagesForStoreFilters: null,
        orderStagesForV1ProjectFilters: null,
    },
    projectRankings: {
        visibleTimeSpans: null,
        rankingsDefaultCategory: null,
        rankingsEnabled: false,
    },
    reCaptchaProvider: {
        siteKey: '',
        isEnabled: false,
    },
    antiForgeryTokenKey: null,
    siteTitle: null,
    siteFeatures: {
        performanceMarketingEnabled: false,
        feastNewsletterEnabled: false,
        partnerNetworkEnabled: false,
        transcendIntegrationEnabled: false,
        ksefSupportEnabled: false,
        legalComplianceEnabled: false,
    },
    helpUrls: {},
};

class ConfigInitializer {
    static configIsInitialized = false;

    static initializeConfig() {
        if (ConfigInitializer.configIsInitialized)
            return;

        if (window.__CONFIG__) {
            config = window.__CONFIG__;
        }

        ConfigInitializer.configIsInitialized = true;
    }
}

ConfigInitializer.initializeConfig();

export default config;
export const navigation = config.navigation;
export const adyenConfig = config.paymentProviders.adyen;
export const googlePayConfig = config.paymentProviders.googlePay;
export const applePay = config.paymentProviders.applePay;
export const externalScripts = config.externalScripts;
export const paymentProviders = config.paymentProviders;
export const userIdentityProviders = config.userIdentityProviders;
export const orderRules = config.orderRules;
export const reCaptchaProvider = config.reCaptchaProvider;
export const externalUrls = config.externalUrls;
export const pushNotifications = config.pushNotifications;
export const stripeConfig = config.paymentProviders.stripe;
